import { createContext, useContext, useEffect, useState } from "react";
import courseServices from "../services/dates";
import { coursesTags } from "./tags";

const courseContextDefaultValues = {
  sfBootcampCourses: [],
  jsBootcampCourses: [],
  introCourses: [],
  atrCourse: null,
  getCourses: () => {},
  loading: false,
  error: false,
};

const CoursesContext = createContext(courseContextDefaultValues);

export const useCourses = () => {
  return useContext(CoursesContext);
};

export const CourseProvider = ({ children }) => {
  const [introCourses, setIntroCourses] = useState([]);
  const [jsBootcampCourses, setJsBootcampCourses] = useState([]);
  const [sfBootcampCourses, setSfBootcampCourses] = useState([]);
  const [atrCourse, setAtrCourse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const getCourses = async () => {
    try {
      setLoading(true);
      const { content } = await courseServices.getCourses();
      const { courses } = content;

      const atr = courses.find(
        (c) => c.cohortLabel.split("-")[0] === coursesTags.INTRO_JAVASCRIPT_ATR
      );

      const live = courses.filter(
        (c) => c.cohortLabel.split("-")[0] === coursesTags.INTRO_JAVASCRIPT
      );
      const jsBc = courses.filter(
        (c) => c.cohortLabel.split("-")[0] === coursesTags.BC_JAVASCRIPT
      );
      const sfBc = courses.filter(
        (c) => c.cohortLabel.split("-")[0] === coursesTags.BC_SALESFORCE
      );

      setIntroCourses(() => live);
      setJsBootcampCourses(() => jsBc);
      setSfBootcampCourses(() => sfBc);
      setAtrCourse(() => atr);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    getCourses();
  }, []);

  const value = {
    sfBootcampCourses,
    jsBootcampCourses,
    introCourses,
    atrCourse,
    getCourses,
    loading,
    error,
  };

  return (
    <CoursesContext.Provider value={value}>{children}</CoursesContext.Provider>
  );
};
